import { render, staticRenderFns } from "./VideoEditor.vue?vue&type=template&id=f3ece820"
import script from "./VideoEditor.vue?vue&type=script&lang=js"
export * from "./VideoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports